import React, { useState, useEffect, useRef, useMemo } from 'react';
import './wbs2iframe.css';
import { showToast } from './toastUtils';
import Swal from 'sweetalert2';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch, apiFetch } from './api';
import { faBullseye } from '@fortawesome/free-solid-svg-icons';
var wbsCodes1 = [];
function Iframe2() {
  const [wbsColumns, setWbsColumns] = useState([]);
  // const [value, setValue] = useState("");
  const [rows, setRows] = useState([]);
  const [newWbsCode, setNewWbsCode] = useState('');
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';  
  const getUserAccess = userDetails ? userDetails.access_level : '';  
  const userId = userDetails ? userDetails.id : '';
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectid = selectedProjectDetail.projectNumber;
  const [loading, setLoading] = useState(true);
  const [WBSLoading, setWBSLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const getUserEmail = localStorage.getItem('userEmail');
  const [userPermission, setUserPermission] = useState(); 
  const [ApprovedBudget, setApprovedBudget] = useState(); 
  const [userRoleManual, setUserRolesManual] = useState();
  const [userCompany, setUserCompany] = useState();
  const getUserCompanyDetails =userCompany;
  const originalListRef = useRef([]);
  const [addedItems, setAddedItems] = useState([]);
  const [totalProjCost, setTotalProjCost] = useState([]);
  const [proj_access_level, setProjAccessLevel] = useState(false);
  //const [isModified, setIsModified] = useState(false);
  // console.log('userId', userId);
  // console.log('ProjectNumber', projectid);
  // console.log('userRoleManual', userRoleManual);
  // console.log('userPermission', userPermission);
  // console.log('userCompanyName', getUserCompanyDetails);
    const fetchData = async () => {
          try {
              await fetchUserCompany();
              await fetchUserRole();
              await getProjectListSalary();
          } catch (error) {
              console.error("Error fetching data:", error);
          }
      };
      
      useEffect(() => {
          
      }, []);

    const getProjectListSalary = async () => {
          const requestOptions = {
            method: 'GET',
            //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
          };
      
          try {
            const response = await queuedApiFetch(`/project/get_user_projectdetails?userid=${userId}&proj_number=${projectid}`, requestOptions);
            const data = await response;
      
            if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
              if (data.data != null) {
                  setApprovedBudget(data.data.Proj_Approved_Budget);
                  // console.log('ApprovedBudget', data.data.Proj_Approved_Budget);
              }
      
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          } finally {
  
          }
        };
      
  
      const fetchUserRole = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectid}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          // console.log(data.data); 
          setUserRolesManual(data.data);
          setProjAccessLevel(data.access_level);
          //setUserRolesManual('Project Manager (PM)');
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          // setLoading(false); // End loading
          
        }
      }
  
      const fetchUserCompany = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
            setUserCompany(data.data.company_name);
            setUserPermission(data.data.access_level);     
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          // setLoading(false); // End loading
          // setTimeout(() => {
          //   setLoading(false);
          // }, 3000);
        }
      }

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat('en-US', { 
        style:'currency', 
        currency: 'USD', 
        currencyDisplay: 'symbol' // This will display the currency code (USD) instead of the symbol.
      }).format(amount);
    };

    // const formatCurrencyinput = (amount) => {
    //   return new Intl.NumberFormat('en-US', { 
    //     currency: 'USD', 
    //   }).format(amount);
    // };

    const formatCurrencyinput = (value) => {
      const num = parseFloat(value);
      if (isNaN(num)) return value;
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };
    
    
  const fetchWBSData = () => {    
    // setLoading(true);
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      // redirect: 'follow',
      // "ngrok-skip-browser-warning": "69420"
    };

    queuedApiFetch('/funding/getwbs?projectid=' + projectid, requestOptions)
      .then((response) => response)
      .then((data) => {
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          const wbsCodes = [...new Set(data.data.map((item) => item.WBS_ID))];
          wbsCodes1 = [...new Set(wbsCodes.map(item => item.toLowerCase()))];
          setWbsColumns(wbsCodes);
          //console.log("Wbs Column",wbsColumns,"wbs cur data",wbsCodes);
          const formattedRows = [
            {
              description: 'BUC No.',
              data: data.data
                .filter((item) => item.DESCRIPTION === 'BUC No.')
                .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
              total: data.data
                .filter((item) => item.DESCRIPTION === 'BUC No.')
                .reduce((acc, item) => acc + item.WBS_VALUE, 0),
            },
            {
              description: 'Fund Code.',
              data: data.data
              .filter((item) => item.DESCRIPTION === 'Fund Code.')
              .map((item) => ({ id: item.ID, value: item.WBS_VALUE })),
              total: data.data
              .filter((item) => item.DESCRIPTION === 'Fund Code.')
              .reduce((acc, item) => acc + item.WBS_VALUE, 0),
            },
            {
              description: 'Approved Budget',
              data: data.data
                .filter((item) => item.DESCRIPTION === 'Approved Budget')
                .map((item) => ({ id: item.ID, value: parseFloat(item.WBS_VALUE) })),
              total: data.data
                .filter((item) => item.DESCRIPTION === 'Approved Budget')
                .reduce((acc, item) => parseFloat(acc) + parseFloat(item.WBS_VALUE), 0),
            },
          ];

          setRows(formattedRows);   
          originalListRef.current =  JSON.parse(JSON.stringify(formattedRows));     
        }
      })
      .catch((error) => console.error('Error fetching data:', error))
      .finally(() => 
        // setLoading(false)
          setTimeout(() => {
            setLoading(false);
          }, 3000)
      )
  };

  //#region Newly added on 12-08-2025
  const fetchAddNewRowData =  async () => {
      //setWBSEditTableLoading(true);
      const requestOptions = {
        method: "GET",
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
      };
    
      try {
        const response = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`,
          requestOptions
        );
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          const transformedData = transformWBSData(data.data);          
          setAddedItems((prevItems) => {
            const updatedItems = prevItems.map((existingItem) => {
              // Find if the group exists in the new transformed data
              const newItem = transformedData.find(
                (newItem) => newItem.group === existingItem.group
              );
    
              // If a matching new item is found, compare the wbsValues
              if (newItem) {
                const wbsValuesMatch =
                  JSON.stringify(existingItem.descriptions.map((desc) => desc.wbsValues)) ===
                  JSON.stringify(newItem.descriptions.map((desc) => desc.wbsValues));
    
                // If wbsValues do not match, update the existing item with newItem's wbsValues
                if (!wbsValuesMatch) {
                  return {
                    ...existingItem,
                    descriptions: newItem.descriptions, // Update the descriptions (which include wbsValues)
                  };
                }
              }
              return existingItem; // If no changes, return the original item
            });
    
            // Add new items that weren't in the previous list
            const newItems = transformedData.filter(
              (newItem) =>
                !prevItems.some((existingItem) => existingItem.group === newItem.group)
            );
    
            // return [...updatedItems, ...newItems]; // Return updated and newly added items
            const combinedItems = [...updatedItems, ...newItems];
              
                // Remove items where descriptions[0].description is null or empty
                return combinedItems.filter(
                  (item) =>
                    item.descriptions.length > 0 &&
                    item.descriptions[0].description !== null &&
                    item.descriptions[0].description !== ""
                );
          });          
          //console.log("Add New row data",addedItems);
          //const tdata=totalCost();
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        //setWBSEditTableLoading(false);
      }
    };
    
  
    const transformWBSData = (data) => {
      const groups = {};
    
      data.forEach((item) => {
        const {
          P_grp_desc,
          P_grp_item_desc,
          P_grp_id,
          P_grp_item_id,
          P_grp_wbs_id,
          P_grp_wbs_value
        } = item;
    
        if (P_grp_id === 1 && P_grp_item_id === 3) return;
  
        if (!groups[P_grp_id]) {
          groups[P_grp_id] = {
            group: P_grp_desc,
            groupId: P_grp_id,
            descriptions: []
          };
        }
    
        const descriptionIndex = groups[P_grp_id].descriptions.findIndex(
          (desc) => desc.description === P_grp_item_desc
        );
    
        if (descriptionIndex === -1) {
          groups[P_grp_id].descriptions.push({
            description: P_grp_item_desc,
            itemId: P_grp_item_id, 
            wbsValues: { [P_grp_wbs_id]: P_grp_wbs_value }
          });
        } else {
          groups[P_grp_id].descriptions[descriptionIndex].wbsValues[P_grp_wbs_id] = P_grp_wbs_value;
        }
      });
  
      Object.values(groups).forEach(group => {
        group.descriptions.sort((a, b) => a.itemId - b.itemId);
      });
    
      // Convert to array
      const groupArray = Object.values(groups);
    
      // Sort according to custom rules
      const startPriority = [1, 2, 3];
      const endPriority = [4, 5];
    
      groupArray.sort((a, b) => {
        const aId = a.groupId;
        const bId = b.groupId;
    
        const aStart = startPriority.indexOf(aId);
        const bStart = startPriority.indexOf(bId);
    
        const aEnd = endPriority.indexOf(aId);
        const bEnd = endPriority.indexOf(bId);
    
        if (aStart !== -1 && bStart !== -1) return aStart - bStart;
        if (aStart !== -1) return -1;
        if (bStart !== -1) return 1;
    
        if (aEnd !== -1 && bEnd !== -1) return aEnd - bEnd;
        if (aEnd !== -1) return 1;
        if (bEnd !== -1) return -1;
    
        return aId - bId;
      });
    
      return groupArray;
    };

    const totalCost=()=>{
        const tcost=wbsColumns.map((_, columnIndex) => {
                const allGroupTotalValue = addedItems.reduce((groupAcc, group) => {
                  return groupAcc + group.descriptions.reduce((descAcc, descriptionObj) => {
                    return descAcc + (parseFloat(descriptionObj.wbsValues?.[wbsColumns[columnIndex]]) || 0);
                  }, 0);
                }, 0);
                const ninePercentValue = allGroupTotalValue * 0.09;
                const totalProjectCost = allGroupTotalValue + ninePercentValue;
                return totalProjectCost;
              });
              setTotalProjCost(tcost);
              //console.log("Total Proj Cost",tcost,"test");
    };

    //#endregion

    useEffect(() => {
      fetchData();
      fetchWBSData();
      //fetchAddNewRowData();      
    }, []);

  useEffect(() => {
    if (wbsColumns.length) {
      //console.log("✅ WBS Columns Updated:", wbsColumns);
      fetchAddNewRowData(); // only run after wbsColumns is set
    }
  }, [wbsColumns]);

useEffect(() => {
  if (wbsColumns.length && addedItems.length) {
    //console.log("✅ Added Items Updated:", addedItems);
    totalCost();
  }
}, [wbsColumns, addedItems]);

  //const originalListRef = useRef(JSON.parse(JSON.stringify(rows))); // Deep copy on mount

  

  // useEffect(() => {
  //   const original = JSON.stringify(originalListRef.current);
  //   const current = JSON.stringify(rows);
  //   setIsModified(original !== current);
  // }, [rows]);

    // const handleInputChange = (rowIndex, cellIndex, newValue) => {
    //   const n = /^[+-]?(\d+(\.\d*)?|\.\d*|\.)$/;
    
    //   // Only format as currency if rowIndex is 2
    //   if (rowIndex >= 2) {
    //     // Remove any non-numeric characters (except for period)
    //     newValue = newValue.replace(/[^0-9.-]+/g, '');
    //   }
    
    //   if ((rowIndex < 2) || (rowIndex >= 2 && n.test(newValue)) || (newValue === '')) {
    //     const updatedRows = [...rows];
    
    //     // If rowIndex is 2, format the value as a number first
    //     updatedRows[rowIndex].data[cellIndex].value = rowIndex < 2 ? newValue : (newValue || 0);
    
    //     if (rowIndex >= 2) {
    //       updatedRows[rowIndex].total = updatedRows[rowIndex].data.reduce(
    //         (acc, item) => parseFloat(acc) + parseFloat(item.value),
    //         0
    //       );
    //     }
    
    //     setRows(updatedRows);
    //   }
    // };
    
    // const handleInputChange = (rowIndex, cellIndex, newValue) => {
    //   const n = /^[+-]?(\d+(\.\d*)?|\.\d*|\.)$/;
    
    //   if (rowIndex >= 2) {
    //     // Remove non-numeric characters except period
    //     newValue = newValue.replace(/[^0-9.-]+/g, '');
    //   }
    
    //   if ((rowIndex < 2) || (rowIndex >= 2 && n.test(newValue)) || (newValue === '')) {
    //     const updatedRows = [...rows];
    //     const numericValue = parseFloat(newValue || 0);
    //     const tempRow = [...updatedRows[rowIndex].data];
    //     tempRow[cellIndex] = { ...tempRow[cellIndex], value: numericValue };
        
    //     const newTotal = tempRow.reduce(
    //       (acc, item) => acc + parseFloat(item.value || 0),
    //       0
    //     );

        // if (rowIndex >= 2 && ApprovedBudget && newTotal > ApprovedBudget) {
        //   showToast.error("Total cannot exceed CPRS approved budget.");
        //   return; 
        // }

    //     updatedRows[rowIndex].data[cellIndex].value = rowIndex < 2 ? newValue : numericValue;
    
    //     if (rowIndex >= 2) {
    //       updatedRows[rowIndex].total = newTotal;
    //     }
    
    //     setRows(updatedRows);
    //   }
    // };

    
  const handleInputChange = (rowIndex, cellIndex, newValue) => {
    const decimalInProgressRegex = /^[+-]?(\d+)?(\.\d{0,2})?$/;

    const cleanedValue = newValue.replace(/,/g, '');

    if ((rowIndex < 2) || (decimalInProgressRegex.test(cleanedValue)) || cleanedValue === '') {
      const updatedRows = [...rows];
      const tempRow = [...updatedRows[rowIndex].data];

      const numericValue = parseFloat(cleanedValue);
      const isValid = !isNaN(numericValue);

      tempRow[cellIndex] = {
        ...tempRow[cellIndex],
        value: isValid ? numericValue : '',
        rawInput: cleanedValue  // store user input separately
      };

      if (rowIndex >= 2) {
        const newTotal = tempRow.reduce(
          (acc, item) => acc + (parseFloat(item.value) || 0),
          0
        );

        const budget = parseFloat(ApprovedBudget);
        if ((!isNaN(newTotal) && newTotal > budget) || (ApprovedBudget == null || isNaN(budget))) {
          showToast.error("Total cannot exceed CPRS approved budget.");
          return;
        }
        updatedRows[rowIndex].total = newTotal;
      }

      updatedRows[rowIndex].data = tempRow;
      setRows(updatedRows);
    }
  };

  function cleanNestedRawInput(dataList) {
    return dataList.map(item => ({
      ...item,
      data: Array.isArray(item.data)
        ? item.data.map(({ rawInput, ...rest }) => rest)
        : []
    }));
  }

  // Compare ref (original) with current editable data
  const isModified = useMemo(() => {

    //     const current = JSON.stringify(rows);
    // const originalData = JSON.parse(rawString);

    // Deep clone and remove "rawInput" fields
    // const cleanedData = rows.map(item => ({
    //   ...item,
    //   data: item.data.map(d => {
    //     const { rawInput, ...rest } = d; // Remove rawInput if it exists
    //     return rest;
    //   })
    //   }));
    const ori_cur = cleanNestedRawInput(originalListRef.current);
    const original = JSON.stringify(ori_cur);

    const cleanedData = cleanNestedRawInput(rows);

    const current = JSON.stringify(cleanedData);

    var sts = (original !== current)

    return sts;


    //return JSON.stringify(rows) !== JSON.stringify(originalListRef.current);
  }, [rows]);
    

    const handleAddWbs = () => {
      if (!WBSLoading) {
        setWBSLoading(true);
        const wbsCodeInput = document.getElementById('wbsCode');
        const wbsRefInput = document.getElementById('wbsRef');
        const fundCodeInput = wbsRefInput.value.trim();
    
        const trimmedWbsCode = newWbsCode.trim();
    
        if (trimmedWbsCode === '') {
          showToast.error('Please enter a valid WBS No');
          wbsCodeInput.style.borderColor = 'red';
          setWBSLoading(false);
          return;
        }
    
        if (wbsCodes1.includes(trimmedWbsCode.toLowerCase())) {
          wbsCodeInput.style.borderColor = 'red';
          showToast.error('WBS No already exists!');
          setWBSLoading(false);
          return;
        }
    
        wbsCodeInput.style.borderColor = '';

        setWbsColumns((prev) => [...prev, trimmedWbsCode]);
        wbsCodes1 = [...wbsCodes1, trimmedWbsCode.toLowerCase()]; 

        const updatedRows = rows.map((row, rowIndex) => ({
          ...row,
          data: [
            ...row.data,
            {
              id: Date.now(), 
              value: rowIndex === 1 ? fundCodeInput : '',
            },
          ],
        }));
    
        setRows(updatedRows);
        setNewWbsCode('');
        wbsRefInput.value = '';
        setWBSLoading(false);
      }
    };
  
  
  const handleSubmit1 = () => {
    if(!submitLoading){
      setSubmitLoading(true);
      setLoading(true);
      // for (const row of rows) {
      //   for (const cell of row.data) {
      //     if (cell.value === '') {
      //       showToast.error('Please fill in all WBS values before submitting.');
      //       // alert('Please fill in all WBS values before submitting.');
      //       setSubmitLoading(false);
      //       return;
      //     }
      //   }
      // }

      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        const row = rows[rowIndex];
  
        for (const cell of row.data) {
          if (cell.value === '') {
            showToast.error('Please fill in all WBS values before submitting.');
            setSubmitLoading(false);
            return;
          }
        }
  

        if (rowIndex >= 2 && ApprovedBudget) {
          const total = row.data.reduce((acc, cell) => acc + parseFloat(cell.value || 0), 0);
          const appr_bud=ApprovedBudget?parseFloat(ApprovedBudget):0;
          // if (total > ApprovedBudget) {
          if (total > appr_bud) {
            showToast.error("Total cannot exceed the approved budget.");
            setSubmitLoading(false);
            return;
          }

          for (let i = 0; i < row.data.length; i++) {
            const currentValue = row.data[i].value;
            const currentTotal = totalProjCost[i];

            if (currentValue < currentTotal) {
              showToast.error("System cannot reduce allocated WBS amount.");
              setSubmitLoading(false);
              return;
            }
          }

          //const cur_totalProjCost=totalProjCost[0];
          // const totalSum = totalProjCost.reduce((acc, val) => acc + val, 0);
          // if(total < totalSum){
          //   showToast.error("System cannot reduce allocated WBS amount.");
          //   setSubmitLoading(false);
          //   return;
          // }
        }
      }
      const prev_data=rows;
      const requestOptions = {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        body: JSON.stringify(
          rows.flatMap((row) =>
            row.data.map((cell, cellIndex) => ({
              id: cell.id,
              description: row.description,
              wbs_id: wbsColumns[cellIndex],
              wbs_value: cell.value,
              Project_id: projectid
            }))
          )
        ),
      };
      try{
                  // originalListRef.current =  JSON.parse(JSON.stringify(prev_data));
      // return false;
      

      queuedApiFetch('/funding/insertwbs', requestOptions)
        .then((response) => response)
        .then((result) => {
          setSubmitLoading(false);
          if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
            // toast.success('Data saved successfully', {
            //   position: "bottom-center",
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "colored",
            //   });

            
            originalListRef.current =  JSON.parse(JSON.stringify(rows));
            showToast.success('Data saved successfully');
            if (result.email_sts == false) {
              Swal.fire("Info", "No emails found for this project. No Email sent !", "info");
            } 
            // alert(result.message || 'Data saved successfully');
          } else {
            // toast.error(result.apistatus.Status_Description ? result.apistatus.Status_Description : 'Please try again later' , {
            //   position: "bottom-center",
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   theme: "colored",
            //   });
            showToast.error(result.apistatus.Status_Description || 'Please try again later');
            // alert(result.apistatus.Status_Description || 'Please try again later');
          }
        })
      }
      catch(error) {
        setLoading(false); 
        console.error('Error saving data:', error)
      } 
      finally{ 
        setLoading(false); 
        setSubmitLoading(false)
      };
    }
  };


  const handleSubmit = async () => {
  if (!submitLoading) {
    setSubmitLoading(true);
    setLoading(true);

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        const row = rows[rowIndex];
  
        for (const cell of row.data) {
          if (cell.value === '') {
            showToast.error('Please fill in all WBS values before submitting.');
            setSubmitLoading(false);
            return;
          }
        }
  

        if (rowIndex >= 2 && ApprovedBudget) {
          const total = row.data.reduce((acc, cell) => acc + parseFloat(cell.value || 0), 0);
          const appr_bud=ApprovedBudget?parseFloat(ApprovedBudget):0;
          // if (total > ApprovedBudget) {
          if (total > appr_bud) {
            showToast.error("Total cannot exceed the approved budget.");
            setSubmitLoading(false);
            return;
          }

          for (let i = 0; i < row.data.length; i++) {
            const currentValue = row.data[i].value;
            const currentTotal = totalProjCost[i];

            if (currentValue < currentTotal) {
              showToast.error("System cannot reduce allocated WBS amount.");
              setSubmitLoading(false);
              return;
            }
          }

          //const cur_totalProjCost=totalProjCost[0];
          // const totalSum = totalProjCost.reduce((acc, val) => acc + val, 0);
          // if(total < totalSum){
          //   showToast.error("System cannot reduce allocated WBS amount.");
          //   setSubmitLoading(false);
          //   return;
          // }
        }
      }

    try {
      const requestOptions = {
        method: 'POST',
        body: JSON.stringify(
          rows.flatMap((row) =>
            row.data.map((cell, cellIndex) => ({
              id: cell.id,
              description: row.description,
              wbs_id: wbsColumns[cellIndex],
              wbs_value: cell.value,
              Project_id: projectid
            }))
          )
        ),
      };

      const result = await queuedApiFetch('/funding/insertwbs', requestOptions);

      if (
        result.apistatus.Status_Code === 200 &&
        result.apistatus.Status_Description.toLowerCase() === 'success'
      ) {
        originalListRef.current = JSON.parse(JSON.stringify(rows));
        showToast.success('Data saved successfully');

        if (result.email_sts == false) {
          Swal.fire("Info", "No emails found for this project. No Email sent !", "info");
        }
      } else {
        showToast.error(result.apistatus.Status_Description || 'Please try again later');
      }

    } catch (error) {
      setLoading(false);
      setSubmitLoading(false);
      console.error('Error saving data:', error);
    } finally {
      setLoading(false);
      setSubmitLoading(false);
    }
  }
};

  // const btn_sts = (
  //         expectedCompany,        
  //         projectAdminRoles = []
  //       ) => {
  //         var sts=(
  //                   // (
  //                   //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
  //                   //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
  //                   //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin') 
  //                   //   // (userRoleManual === 'Admin' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
  //                   // )

  //           (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && (userRoleManual?.length===0 || projectAdminRoles.some(item=>userRoleManual?.includes?.(item))))                  
            
  //         );         
  //         return sts;
  //       };

    const btn_sts = (
          expectedCompany,        
          projectAdminRoles = []
        ) => {
          var sts=(
            // ((getUserCompanyDetails === expectedCompany && proj_access_level === true) || projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))       
            projectAdminRoles.some(item => userRoleManual?.includes?.(item))           
            
          );         
          return sts;
        };

  return (
    <div className="bodywrapp">
      {loading && <FullscreenLoader />} 
      <div className="header">
        <div className="projectwrap">
          <div className="addwbswrap">
            <input
              type="text"
              id="wbsCode"
              placeholder="WBS No"
              value={newWbsCode}
              onChange={(e) => setNewWbsCode(e.target.value)}
            />
            <input type="text" id="wbsRef" placeholder="Fund Code" />
            <button 
                id="addWbs" 
                disabled={
                  !( 
                    WBSLoading === false && (btn_sts("NUS",['Admin']))
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin') 
                    //   // (userRoleManual === 'Admin' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // )
                  )
                }
                onClick={handleAddWbs}
                style={{
                      padding: '10px 20px',
                  backgroundColor: 
                    // (
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                    //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin') 
                    //   // (userRoleManual === 'Admin' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                    // ) 
                    (btn_sts("NUS",['Admin']))? '' : 'grey'
                }}
              >
              Add WBS
            </button>

          </div>

          {/* <button
            id="submit"
            disabled={
              !submitLoading && userRoleManual === 'Admin'
                ? false
                : ((userPermission === 'project_admin' || userPermission === 'account_admin') ? false : true)
            }
            onClick={handleSubmit}
            style={{
              backgroundColor: (userPermission === 'project_admin' || userPermission === 'account_admin') ? '' : 'grey'
            }}
          >
            Save
          </button> */}
          <button
            id="submit"
            // disabled={
            //   !submitLoading && userRoleManual === 'Admin'
            //     ? false
            //     : ((userPermission === 'project_admin' || userPermission === 'account_admin') ? false : true)
            // }

            disabled={
              !( 
                submitLoading === false && (btn_sts("NUS",['Admin'])) && isModified
                // (
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin') 
                //   // (userRoleManual === 'Admin' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                // )
              )
            }
            onClick={handleSubmit}
            style={{
              borderRadius: '10px',
              backgroundColor: 
                // (
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'account_admin') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === '') ||
                //   (getUserCompanyDetails === 'NUS' && userPermission === 'project_admin' && userRoleManual === 'Admin') 
                //   // (userRoleManual === 'Admin' && (userPermission === 'project_admin' || userPermission === 'account_admin'))
                // ) 
                (btn_sts("NUS",['Admin']) && isModified) ? '' : 'grey'
            }}
          >
            Save
          </button>
        </div>
      </div>

      <div className="tablewrap" id="wbs_tablewrap">
        <table id="wbsTable">
          <thead>
            <tr>
              <th className="description-column" colSpan="1">
              WBS No
              </th>
              {wbsColumns.map((column, index) => (
                <th key={index}>{column}</th>
              ))}
              <th className="description-column">Total</th>
            </tr>
          </thead>
          <tbody>
          {rows.length === 0 ? (
            <tr>
                <td colSpan={wbsColumns.length + 2} style={{ textAlign: 'center', height: '100px', verticalAlign: 'middle', padding: '20px' }}>{loading ? 'Loading...' : 'No records found'}</td>
            </tr>
            ) : (
            rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {/* <td className="undescription-column">{row.description}</td> */}
                   <td
                    className={
                      rowIndex > 1
                        ? "undescription-column-2"
                        : "undescription-column"
                    }
                  >
                    {row.description}
                  </td>
                {row.data.map((cellData, cellIndex) => (
                  <td key={cellIndex}
                      className={
                        rowIndex > 1
                          ? "undescription-column-2"
                          : "undescription-column"
                      }>
                    {/* add $ sign to the input field */}
                    {rowIndex === 2 ? '$' : ''}
                      &nbsp;
                      <input
                        className="custom-input"
                        type="text"
                        value={
                          cellData.rawInput !== undefined
                            ? cellData.rawInput
                            : cellData.value !== undefined
                            ? rowIndex === 2
                              ? formatCurrencyinput(cellData.value)
                              : cellData.value
                            : ''
                        }
                        onChange={(e) =>
                          handleInputChange(rowIndex, cellIndex, e.target.value)
                        }
                        onBlur={(e) => {
                          const inputValue = e.target.value;
                          const updatedRows = [...rows];
                        
                          if (rowIndex === 2) {
                            // Currency field
                            const cleaned = inputValue.replace(/,/g, '');
                            const value = parseFloat(cleaned);
                        
                            if (!isNaN(value)) {
                              updatedRows[rowIndex].data[cellIndex] = {
                                ...updatedRows[rowIndex].data[cellIndex],
                                value,
                                rawInput: formatCurrencyinput(value),
                              };
                            } else {
                              updatedRows[rowIndex].data[cellIndex] = {
                                ...updatedRows[rowIndex].data[cellIndex],
                                value: '',
                                rawInput: '',
                              };
                            }
                          } else {
                            // Regular text field
                            updatedRows[rowIndex].data[cellIndex] = {
                              ...updatedRows[rowIndex].data[cellIndex],
                              value: inputValue,
                              rawInput: inputValue,
                            };
                          }
                        
                          setRows(updatedRows);
                        }}                        
                      />
                  </td>
                ))}
                {/* <td className="total-column">{rowIndex < 2 ? "" : formatCurrency(row.total)}</td> */}
                  {rowIndex !== 1 && (
                    <td
                      className={
                        rowIndex > 1
                          ? "undescription-column-2"
                          : "undescription-column"
                      }
                      rowSpan={rowIndex == 0 ? 2 : 0}
                    >
                      {rowIndex < 2 ? "" : formatCurrency(row.total)}
                    </td>
                  )}
              </tr>
            ))
          )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Iframe2;
